"use client";
import React from "react";
import { SiteLogo } from "@/components/svg";
import { Loader2 } from "lucide-react";
const LayoutLoader = () => {
  return (
    <div className="h-screen flex items-center justify-center flex-col space-y-2">
      <div className="w-32 h-8">
        <SiteLogo className="w-full h-full" />
      </div>
      <span className="inline-flex gap-1">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        Loading...
      </span>
    </div>
  );
};

export default LayoutLoader;
